import React, { Component} from 'react';
import AtozLinks from './atozLinks';
import GAToZLoader from './gatozLoader';
class graduate extends Component {

  renderItems() {
    let letterSort=[];
    for (let i = 0; i <= 25; i++) {
      letterSort[i]=[];
    }
  
      let currentLetter="A";
      let innterCount=0;
      let outerCount=0;
  
      this.props.data.forEach(function(item){
        
          let firstLetter=item.attributes.label.charAt(0);
          if(firstLetter!==currentLetter){
              currentLetter=firstLetter;
              innterCount=0;
              outerCount++;
              }
        
          if(item.attributes.graduate !=null){      
                  letterSort[outerCount][innterCount]=item.attributes;
                  letterSort[outerCount][innterCount].currentLetter=currentLetter+'gr';
                  letterSort[outerCount][innterCount].id=item.id;  
                  innterCount++;
          }
              
      });
      
    return   letterSort.map((item, i) => (
      <div key={i} className="AtoZDegrees"             style={{ 
        animationFillMode: "both",
        animationDuration: "1000ms",
        animationDelay: "0ms",
        animationIterationCount: "1",
        opacity: "1",
        animationName: "react-reveal-724875713033443-1",
        textAlign:"center",
    }}>
        <GAToZLoader item={item} type="G" />  
      </div>
      
  ));
  
  }
  renderMenu(){
  
    let usedLetters=[];
    let currentLetter="A";
    
      //let innterCount=0;
      let outerCount=0;
      this.props.data.forEach(function(item){
        let firstLetter=item.attributes.label.charAt(0);
        if(firstLetter===currentLetter && outerCount===0){
            usedLetters[outerCount]=currentLetter;
            outerCount++;
          } 
        else if(firstLetter!==currentLetter){
          
              usedLetters[outerCount]=firstLetter;
              currentLetter=firstLetter;
              outerCount++;
            }
       
      });
      usedLetters[outerCount]="gr";
      return  (
       
        <div className="letterMenu">
              <AtozLinks letters={usedLetters} /> 
        </div>
        );
  } 
  render() {
   
      return(
         
        <div className="graduate" style={{
            
        }} >
      <div className="title menu" 
      style={{width:"100%",backgroundColor:"#fff", fontWeight:"bold",}}
      >
          {this.renderMenu()}
         
      </div>
      <div style={{
            padding: "10px",
            columnCount: window.innerWidth>1100?"3":window.innerWidth>899?"2":"1",
            textAlign: "center",
            float:window.innerWidth>899?null:"left",
           
      }}>
      {this.renderItems()}
      </div>
  </div>
         
      );       
  }
}
  
  

export default graduate;